import { render, staticRenderFns } from "./MarketData.vue?vue&type=template&id=3ef7dcdc&"
import script from "./MarketData.vue?vue&type=script&lang=ts&"
export * from "./MarketData.vue?vue&type=script&lang=ts&"
import style0 from "./MarketData.vue?vue&type=style&index=0&id=3ef7dcdc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports